import axios from "axios";
import { isEmpty, uniq } from "lodash";
const INCLUDE_ATTACHMENT_ID = "cb_mr[cb_mr_attachment]";

/**
 * Mixin functions used from
 * - modal-export.vue
 * - modal-export-soap.vue
 * @mixin
 */
export default {
    computed: {
        patientId() {
            return this.patientDetails.id;
        },
        emailPage1() {
            return this.action === "email" && this.currentPage === 1;
        },
        emailPage2() {
            return this.action === "email" && this.currentPage === 2;
        }
    },
    methods: {
        prev() {
            this.currentPage = 1;
            this.isNextRequireFetch = false;
        },
        close() {
            this.$refs.dialog.hide();
        },
        tinymceKeydown() {
            if (!this.initialContentChangedByUser) {
                this.initialContentChangedByUser = true;
            }

            return true;
        },
        selectAllFilter() {
            this.selectedFilters = [];

            if (this.includeAll) {
                for (const item of this.filters) {
                    this.selectedFilters.push(item.id);
                }
            }
        },
        setDefaultRecipient() {
            const { primary_owner: owners } = this.patientDetails;

            for (const owner of owners) {
                if (owner && owner.email && owner.email !== "") {
                    this.clientDetails = owner;
                    this.recipientComponentKey++; // force re-render
                    break;
                }
            }
        },
        async fetchVeterinarians() {
            try {
                this.isLoadingVeterinarian = true;

                const res = await axios.get(
                    `${process.env.BARRAMUNDI}actor/staff/business/providers`
                );

                const response = res.data.response;

                if (response && response.resource && response.resource.data) {
                    let options = this.properVetList(response.resource.data);
                    this.isLoadingVeterinarian = false;
                    this.veterinarianOptions = options;

                    let currentActor = this.$root.currentActor.id;
                    let isProvider = options.find(
                        opt => opt.value === currentActor
                    );

                    if (isProvider) {
                        this.veterinarian = currentActor;
                    } else {
                        this.veterinarian = options[0] ? options[0].value : "";
                    }
                } else {
                    throw new Error("Unable to fetch veterinarian list.");
                }
            } catch (e) {
                this.isLoadingVeterinarian = false;
                this._message(e.message, "danger");
            }
        },
        properVetList(rawData = []) {
            let result = [];
            rawData = _.sortBy(rawData, "actor.lastname");

            for (const record of rawData) {
                result.push({
                    text: record.actor.label,
                    value: record.actor.id
                });
            }

            return result;
        },
        properFilter(rawObject = {}) {
            let result = [];

            for (const key in rawObject) {
                const item = rawObject[key];
                const rootPrefix = "cb";

                let label = item.label;
                let children = [];
                let childrenIds = [];
                let itemId = `${rootPrefix}[${rootPrefix}_${item.id}]`;

                // number
                if (typeof item.data === "number") {
                    if (item.data <= 0) {
                        continue;
                    }
                    if (item.id === "attachment" && item.files?.length > 0) {
                        this.attachmentOption = item.files;
                        this.attachments = item.files;
                    }

                    if (this.isSoap && item.id === "medical_note") {
                        // As in soap will show 1 medical note, so no need to show the count
                        label = `${item.label}`;
                    } else {
                        label = `${item.label} (${item.data})`;
                    }
                }
                // array
                else if (Array.isArray(item.data)) {
                    if (item.data.length === 0) {
                        continue;
                    }

                    let prefix = "";
                    if (item.id === "diagnosis") {
                        prefix = "cb_d";
                    } else if (item.id === "problems") {
                        prefix = "cb_p";
                    } else if (item.id === "medical_record") {
                        prefix = "cb_mr";
                    }

                    for (const child of item.data) {
                        if (child.total > 0) {
                            // let id = prefix + child.type;
                            let id = `${prefix}[${prefix}_${child.type}]`;
                            childrenIds.push(id);

                            children.push({
                                id: id,
                                label: `${child.label} (${child.total})`,
                                originalLabel: child.label,
                                total: child.total,
                                parentId: itemId,
                                type: "child",
                                children: []
                            });

                            // append lower-children for medical records, lab
                            if (
                                item.id === "medical_record" &&
                                child.type === 7
                            ) {
                                children.push({
                                    id: INCLUDE_ATTACHMENT_ID, // <-- hopefully this id is unique (referred based on CI). potential bug if got same id.
                                    label: "Include Attachments",
                                    type: "lower-child",
                                    parentId: id,
                                    parentParentId: itemId // To avoid confusion of using itemId as the key, so name it as parentParentId which indicate the parent of parentId
                                });

                                const theParent = children.find(
                                    r => r.id === id
                                );

                                if (theParent) {
                                    theParent.children.push(
                                        INCLUDE_ATTACHMENT_ID
                                    );
                                }
                            }
                        }
                    }
                }

                result.push({
                    id: itemId,
                    label: label,
                    children: childrenIds
                });

                result.push(...children);
            }

            return result;
        },
        /**
         * @method selectItemFilter
         * @description this function is based on selectItemFilter from src/components/soap/modal-export-soap.vue
         * for Soap,this function has been refactor and follow the CI soap behaviour which check/unchecked the parent with include attachment will also apply the include attachment checkbox
         * VET-8231 - The export from patient will have the lower-child (include attachment) as optional
         * @param {Event} event
         * @param {Object} item
         */
        selectItemFilter(event, item) {
            let self = this;
            this.includeAll = false;
            let isChecked = event.target.checked;

            if (item) {
                // Is unchecked
                // Uncheck the lower-child (include attachment) will not auto uncheck its parent as include attachment is optional
                if (!isChecked && item.type !== "lower-child") {
                    // unchecked all children and their children
                    if (!isEmpty(item.children)) {
                        this.selectedFilters = this.selectedFilters.filter(
                            id => !item.children.includes(id)
                        );

                        let children3rdLayer = [];
                        children3rdLayer = this.filters.filter(i => item.children.includes(i.id) && !isEmpty(i.children)).map(filtered => filtered.children).flat(); // prettier-ignore

                        if (!isEmpty(children3rdLayer)) {
                            this.selectedFilters = this.selectedFilters.filter(
                                id => !children3rdLayer.includes(id)
                            );
                        }
                    }

                    // uncheck parent, if all children has been unchecked
                    if (item.parentId) {
                        let isParentShouldChecked = this.uncheckParent(
                            item.parentId
                        );

                        // If the parent uncheck, then uncheck the parent item if all the docs has been unchecked
                        if (!isParentShouldChecked && item.parentParentId) {
                            this.uncheckParent(item.parentParentId);
                        }
                    }
                } else if (isChecked) {
                    // Is checked

                    // check the parent
                    console.log(item);
                    if (
                        item.parentId &&
                        !this.selectedFilters.includes(item.parentId)
                    ) {
                        this.selectedFilters.push(item.parentId);
                    }

                    // check the parent parent (if the checkbox is in the 3rd level)
                    if (
                        item.parentParentId &&
                        !this.selectedFilters.includes(item.parentParentId)
                    ) {
                        this.selectedFilters.push(item.parentParentId);
                    }

                    // check children if any
                    if (!isEmpty(item.children)) {
                        // Retrieve all the children of the children
                        // As currently only retrieve the children of medical note (include attachment) in soap
                        let children3rdLayer = [];
                        if (self.isSoap) {
                            children3rdLayer = this.filters.filter(i => item.children.includes(i.id) && !isEmpty(i.children)).map(filtered => filtered.children).flat(); // prettier-ignore
                        }

                        // As parent check, all children will be also checked
                        this.selectedFilters = uniq(
                            this.selectedFilters.concat(
                                item.children.filter(
                                    childId =>
                                        childId !== INCLUDE_ATTACHMENT_ID ||
                                        self.isSoap
                                ),
                                children3rdLayer
                            )
                        );
                    }
                }
            }

            // check include all if all items are checked
            if (this.selectedFilters.length === this.filters.length) {
                this.includeAll = true;
            }
        },
        uncheckParent(itemParentId) {
            let children = this.filters.filter(i => i.parentId === itemParentId); // prettier-ignore
            let isParentShouldChecked = false;

            isParentShouldChecked = children.some(child => this.selectedFilters.includes(child.id)); // prettier-ignore

            if (!isParentShouldChecked) {
                this.selectedFilters = this.selectedFilters.filter(
                    id => id !== itemParentId
                );
            }

            return isParentShouldChecked;
        }
    }
};
